//禁止修改此文件
import './../assets/icons'
import DataUtil from './data.js'
import Vue from 'vue';
Vue.prototype.ConstData = DataUtil;
